/* Livset Pazar — koleksiyon/arama filtreleri, sıralama, daha fazla yükle (Section Rendering API) */
(() => {
  const L = window.Livset;
  if (!L || customElements.get('facets-root')) return;

  const REPLACE = ['[data-facets-count]', '[data-quick-filters]', '[data-mobile-toolbar]', '[data-facets-results]'];

  class FacetsRoot extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.baseUrl = this.dataset.baseUrl || location.pathname;
      this.priceDebounced = L.debounce(() => this.submit(), 700);

      this.addEventListener('change', (e) => {
        const t = e.target;
        if (t.matches('[data-sort-select]')) {
          const input = this.querySelector('[data-sort-input]');
          if (input) input.value = t.value;
          else return this.load(this.urlWith({ sort_by: t.value }));
          return this.submit();
        }
        if (t.matches('[data-price-input], [data-facet-search]')) return;
        if (t.closest('[data-facets-form]')) this.submit();
      });

      this.addEventListener('input', (e) => {
        const t = e.target;
        if (t.matches('[data-price-input]')) this.priceDebounced();
        if (t.matches('[data-facet-search]')) {
          const q = t.value.trim().toLocaleLowerCase('tr');
          const list = t.closest('.facet__body').querySelector('.facet__list');
          list && list.querySelectorAll('li').forEach((li) => (li.hidden = q && !li.dataset.facetLabel.includes(q)));
        }
      });

      this.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facet-link], [data-facets-clear]');
        if (link) {
          e.preventDefault();
          return this.load(link.href);
        }
        const quick = e.target.closest('[data-quick-filter]');
        if (quick) {
          const form = this.querySelector('[data-facets-form]');
          const box = form && [...form.querySelectorAll(`input[name="${CSS.escape(quick.dataset.name)}"]`)].find((i) => i.value === quick.dataset.value);
          if (box) {
            box.checked = !box.checked;
            this.submit();
          } else {
            const url = new URL(location.href);
            url.searchParams.append(quick.dataset.name, quick.dataset.value);
            this.load(url.toString());
          }
          return;
        }
        const more = e.target.closest('[data-load-more]');
        if (more) {
          e.preventDefault();
          this.loadMore(more);
        }
      });

      window.addEventListener('popstate', (e) => {
        if (e.state && e.state.facets) this.load(location.href, false);
      });
      history.replaceState({ ...(history.state || {}), facets: true }, '', location.href);
      this.observeMore();
      this.updateBadge(document);
    }

    urlWith(params) {
      const url = new URL(location.href);
      Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));
      url.searchParams.delete('page');
      return url.toString();
    }

    submit() {
      const form = this.querySelector('[data-facets-form]');
      if (!form) return;
      const params = new URLSearchParams();
      for (const [k, v] of new FormData(form)) {
        if (v !== '') params.append(k, v);
      }
      this.load(`${this.baseUrl}?${params.toString()}`);
    }

    async load(url, push = true) {
      this.classList.add('is-loading');
      this.abort && this.abort.abort();
      this.abort = new AbortController();
      try {
        const u = new URL(url, location.origin);
        u.searchParams.set('section_id', this.sectionId);
        const res = await fetch(u.toString(), { signal: this.abort.signal });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        this.swap(doc);
        if (push) {
          const clean = new URL(url, location.origin);
          clean.searchParams.delete('section_id');
          history.pushState({ facets: true }, '', clean.pathname + clean.search);
        }
      } catch (err) {
        if (err.name !== 'AbortError') location.href = url;
      } finally {
        this.classList.remove('is-loading');
      }
    }

    swap(doc) {
      REPLACE.forEach((sel) => {
        const cur = this.querySelector(sel);
        const next = doc.querySelector(sel);
        if (cur && next) cur.replaceWith(document.importNode(next, true));
      });
      // Filtre formu: açık grupları ve kaydırma konumunu koru (mobil çekmece açıkken)
      const form = this.querySelector('[data-facets-form]');
      const nextForm = doc.querySelector('[data-facets-form]');
      if (form && nextForm) {
        const open = new Set([...form.querySelectorAll('details.facet')].map((d, i) => (d.open ? i : -1)).filter((i) => i > -1));
        const body = form.closest('.facets__body');
        const scroll = body ? body.scrollTop : 0;
        const searches = [...form.querySelectorAll('[data-facet-search]')].map((s) => s.value);
        form.innerHTML = nextForm.innerHTML;
        form.querySelectorAll('details.facet').forEach((d, i) => (d.open = open.has(i) || d.open));
        form.querySelectorAll('[data-facet-search]').forEach((s, i) => {
          if (searches[i]) {
            s.value = searches[i];
            s.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });
        if (body) body.scrollTop = scroll;
      }
      const foot = this.querySelector('.facets__foot');
      const nextFoot = doc.querySelector('.facets__foot');
      if (foot && nextFoot) foot.innerHTML = nextFoot.innerHTML;
      this.updateBadge(this);
      L.favs && L.favs.sync(this);
      this.observeMore();
    }

    updateBadge(root) {
      const count = root.querySelectorAll('[data-facets-active] .chip').length;
      this.querySelectorAll('[data-facets-badge]').forEach((b) => {
        b.textContent = count;
        b.hidden = count === 0;
      });
    }

    async loadMore(btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      try {
        const doc = await L.fetchSection(btn.href, this.sectionId);
        const grid = this.querySelector('[data-grid]');
        const items = doc.querySelectorAll('[data-grid] > li');
        items.forEach((li) => grid.append(document.importNode(li, true)));
        const pag = this.querySelector('[data-pagination]');
        const nextPag = doc.querySelector('[data-pagination]');
        if (pag && nextPag) pag.replaceWith(document.importNode(nextPag, true));
        L.favs && L.favs.sync(grid);
        this.observeMore();
      } catch (_) {
        location.href = btn.href;
      }
    }

    observeMore() {
      this.io && this.io.disconnect();
      const btn = this.querySelector('[data-load-more]');
      if (!btn || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) this.loadMore(btn);
      }, { rootMargin: '600px 0px' });
      this.io.observe(btn);
    }
  }
  customElements.define('facets-root', FacetsRoot);
})();
